var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPainScore10(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80.522,
    height: 80.525,
    viewBox: "0 0 80.522 80.525",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-painscore10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3536",
    "data-name": "Path 3536",
    d: "M550.392-30.237A39.262,39.262,0,0,1,511.13,9.025a39.26,39.26,0,0,1-39.26-39.262A39.26,39.26,0,0,1,511.13-69.5a39.262,39.262,0,0,1,39.262,39.263",
    transform: "translate(-471.87 69.5)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2-painscore10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3541",
    "data-name": "Path 3541",
    d: "M508.583-44.872a6.55,6.55,0,0,0,6.69,6.4,6.551,6.551,0,0,0,6.689-6.4,6.553,6.553,0,0,0-6.689-6.4,6.551,6.551,0,0,0-6.69,6.4",
    transform: "translate(-508.583 51.276)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3-painscore10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3547",
    "data-name": "Path 3547",
    d: "M509.407-43.692a6.971,6.971,0,0,1-7.118,6.813,6.97,6.97,0,0,1-7.116-6.813A6.969,6.969,0,0,1,502.29-50.5a6.97,6.97,0,0,1,7.118,6.812",
    transform: "translate(-495.173 50.504)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4-painscore10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3674",
    "data-name": "Path 3674",
    d: "M500.6-43.523a2.535,2.535,0,0,0,2.534,2.535,2.535,2.535,0,0,0,2.535-2.535,2.535,2.535,0,0,0-2.535-2.533,2.535,2.535,0,0,0-2.534,2.533",
    transform: "translate(-500.597 46.055)",
    fill: "#00142e",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5-painscore10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3677",
    "data-name": "Path 3677",
    d: "M501.893-43.723a1.038,1.038,0,0,0,1.038,1.038,1.04,1.04,0,0,0,1.039-1.038,1.037,1.037,0,0,0-1.039-1.034,1.035,1.035,0,0,0-1.038,1.034",
    transform: "translate(-501.893 44.757)",
    fill: "#00142e",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6-painscore10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3680",
    "data-name": "Path 3680",
    d: "M511.434-44.818a2.534,2.534,0,0,0,2.533,2.533,2.534,2.534,0,0,0,2.536-2.533,2.534,2.534,0,0,0-2.536-2.534,2.534,2.534,0,0,0-2.533,2.534",
    transform: "translate(-511.434 47.351)",
    fill: "#00142e",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7-painscore10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3683",
    "data-name": "Path 3683",
    d: "M512.731-45.018a1.036,1.036,0,0,0,1.035,1.035,1.039,1.039,0,0,0,1.041-1.035,1.04,1.04,0,0,0-1.041-1.037,1.037,1.037,0,0,0-1.035,1.037",
    transform: "translate(-512.731 46.054)",
    fill: "#00142e",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8-painscore10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3713",
    "data-name": "Path 3713",
    d: "M496.227-40.615a3.931,3.931,0,0,0,.61,2.494,9.794,9.794,0,0,1,1.093,2.007,3.33,3.33,0,0,1,2.008-1.7c1.4-.365,1.643-2.556.912-2.92s-4.623.122-4.623.122",
    transform: "translate(-496.21 40.873)",
    fill: "#eff0f2",
    clipRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pain_10",
    "data-name": "Pain 10",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3712",
    "data-name": "Group 3712",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-painscore10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3535",
    "data-name": "Path 3535",
    d: "M470.87-70.5H551.7V10.334H470.87Z",
    transform: "translate(-472.024 69.346)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3714",
    "data-name": "Group 3714",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3538",
    "data-name": "Path 3538",
    d: "M78.522,39.263A39.261,39.261,0,1,1,39.26,0,39.262,39.262,0,0,1,78.522,39.263Z",
    fill: "none",
    stroke: "#00142e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3716",
    "data-name": "Group 3716",
    transform: "translate(42.378 21.036)",
    clipPath: "url(#clip-path-2-painscore10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3540",
    "data-name": "Path 3540",
    d: "M507.583-52.276h15.688v15.115H507.583Z",
    transform: "translate(-508.737 51.122)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3718",
    "data-name": "Group 3718",
    transform: "translate(42.378 21.036)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3543",
    "data-name": "Path 3543",
    d: "M0,6.4a6.55,6.55,0,0,0,6.69,6.4A6.551,6.551,0,0,0,13.38,6.4,6.553,6.553,0,0,0,6.69,0,6.551,6.551,0,0,0,0,6.4Z",
    fill: "none",
    stroke: "#00142e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3719",
    "data-name": "Group 3719",
    transform: "translate(44.048 23.21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3544",
    "data-name": "Path 3544",
    d: "M0,0S8,3.291,8.768,9.536",
    fill: "none",
    stroke: "#00142e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3721",
    "data-name": "Group 3721",
    transform: "translate(26.9 21.928)",
    clipPath: "url(#clip-path-3-painscore10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3546",
    "data-name": "Path 3546",
    d: "M494.173-51.5h16.543v15.933H494.173Z",
    transform: "translate(-495.328 50.349)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3723",
    "data-name": "Group 3723",
    transform: "translate(26.9 21.928)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3549",
    "data-name": "Path 3549",
    d: "M14.234,6.812a6.971,6.971,0,0,1-7.118,6.813A6.97,6.97,0,0,1,0,6.812,6.969,6.969,0,0,1,7.116,0,6.97,6.97,0,0,1,14.234,6.812Z",
    fill: "none",
    stroke: "#00142e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3818",
    "data-name": "Group 3818",
    transform: "translate(33.16 27.062)",
    clipPath: "url(#clip-path-4-painscore10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3673",
    "data-name": "Path 3673",
    d: "M499.6-47.056h7.377v7.376H499.6Z",
    transform: "translate(-500.752 45.901)",
    fill: "#00142e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3820",
    "data-name": "Group 3820",
    transform: "translate(34.656 28.561)",
    clipPath: "url(#clip-path-5-painscore10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3676",
    "data-name": "Path 3676",
    d: "M500.893-45.757h4.385v4.381h-4.385Z",
    transform: "translate(-502.047 44.603)",
    fill: "#00142e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3822",
    "data-name": "Group 3822",
    transform: "translate(45.67 25.567)",
    clipPath: "url(#clip-path-6-painscore10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3679",
    "data-name": "Path 3679",
    d: "M510.434-48.351h7.377v7.375h-7.377Z",
    transform: "translate(-511.589 47.197)",
    fill: "#00142e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3824",
    "data-name": "Group 3824",
    transform: "translate(47.167 27.064)",
    clipPath: "url(#clip-path-7-painscore10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3682",
    "data-name": "Path 3682",
    d: "M511.731-47.054h4.385v4.381h-4.385Z",
    transform: "translate(-512.885 45.9)",
    fill: "#00142e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3844",
    "data-name": "Group 3844",
    transform: "translate(25.133 49.412)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3703",
    "data-name": "Path 3703",
    d: "M0,15.1S3.952,4.39,5.656,2.384,11.434.072,14.17.01,19.342.192,21.9.192s4.745,2.009,7.12,5.66a42.788,42.788,0,0,1,4.012,8.94",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#00142e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3845",
    "data-name": "Group 3845",
    transform: "translate(24.555 41.334)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3704",
    "data-name": "Path 3704",
    d: "M1.184.241S.274,3.161.029,4.134s1.094.73,1.947.426S3.008,2.8,2.889,1.823,1.436-.571,1.184.241Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#00142e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3846",
    "data-name": "Group 3846",
    transform: "translate(55.06 45.867)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3705",
    "data-name": "Path 3705",
    d: "M.667.21A10.058,10.058,0,0,0,0,3.737C0,5.684.667,5.5,1.641,5.38S2.8,4.467,2.8,3.372,1.005-.831.667.21Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#00142e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3847",
    "data-name": "Group 3847",
    transform: "translate(54.03 37.474)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3706",
    "data-name": "Path 3706",
    d: "M1.15.147C1.268-.33.541.331.176,2.459S-.005,5.621.908,5.438s2.8-1.214,2.25-2.189S1.03.634,1.15.147Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#00142e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3848",
    "data-name": "Group 3848",
    transform: "translate(34.906 38.412)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3707",
    "data-name": "Path 3707",
    d: "M.019,0s-.3,2.677,1.519,2.677,2.131-.366,3.408.425,2.8,2.19,3.955,1.7,1.763-1.523,2.919-1.523,1.4-.67,1.825-1.764,0-1.52,0-1.52",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#00142e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3849",
    "data-name": "Group 3849",
    transform: "translate(18.443 14.323)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3708",
    "data-name": "Path 3708",
    d: "M0,17.458S12.713,12.349,16.238,0",
    fill: "none",
    stroke: "#00142e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3850",
    "data-name": "Group 3850",
    transform: "translate(30.03 24.239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3709",
    "data-name": "Path 3709",
    d: "M9.326,0S.82,3.5,0,10.144",
    fill: "none",
    stroke: "#00142e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3851",
    "data-name": "Group 3851",
    transform: "translate(46.727 15.966)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3710",
    "data-name": "Path 3710",
    d: "M0,0S8.457,11.254,17.639,12.044",
    fill: "none",
    stroke: "#00142e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3853",
    "data-name": "Group 3853",
    transform: "translate(28.096 33.045)",
    clipPath: "url(#clip-path-8-painscore10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3712",
    "data-name": "Path 3712",
    d: "M495.069-42.072h7.842v7.3h-7.842Z",
    transform: "translate(-496.386 40.688)",
    fill: "#eff0f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3855",
    "data-name": "Group 3855",
    transform: "translate(28.096 33.045)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3715",
    "data-name": "Path 3715",
    d: "M.018.258A3.931,3.931,0,0,0,.627,2.752,9.793,9.793,0,0,1,1.72,4.76a3.33,3.33,0,0,1,2.009-1.7C5.129,2.691,5.371.5,4.641.136S.018.258.018.258Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#00142e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPainScore10);
export default __webpack_public_path__ + "static/media/pain_score_10.6b5ea723.svg";
export { ForwardRef as ReactComponent };